/** A number for a CSS or SVG attribute: at most two decimals, never localised, never a displayed value. */
export function num(value: number): string {
  return String(Math.round(value * 100) / 100)
}
